// third-party
import { FormattedMessage } from "react-intl";
import { generarGUID } from "../FN/_FN";
// assets
import {
  DocumentCode2,
  I24Support,
  Driving,
  Book,
  PasswordCheck,
  Next,
  RowVertical,
  CpuCharge,
  Subtitle,
  Truck,
  Personalcard,
  NoteText,
  OceanProtocol,
  UserOctagon,
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  TableDocument,
  Edit,
  Edit2,
  Chart,
  Firstline,
  FolderOpen,
  MessageText1,
  MessageProgramming,
  Note
} from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  samplePage: DocumentCode2,
  documentation: I24Support,
  roadmap: Driving,
  formsTable: Book,
  validation: PasswordCheck,
  wizard: Next,
  layout: RowVertical,
  plugins: CpuCharge,
  reactTables: TableDocument,
  muiTables: Subtitle,
  usr: Profile2User,
  truck: Truck,
  chofer: Driving,
  broker: UserOctagon,
  applications: KyberNetwork,
  chat: Messages2,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag,
  doc: TableDocument,
  EditCargado: Edit,
  EditVacio: Edit2,
  Personalcard: Personalcard,
  NoteText: NoteText,
  OceanProtocol: OceanProtocol,
  Chart: Chart,
  Firstline: Firstline,
  FolderOpen: FolderOpen,
  MessageText1: MessageText1,
  MessageProgramming: MessageProgramming,
  Note:Note
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const Menu_T_AND_M: NavItemType = {
  id: "other",
  title: <FormattedMessage id="others" />,
  type: "group",
  children: [
    {
      id: "sample-page",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      url: "/dashboard",
      icon: icons.Chart,
      // external: true,
      // target: true,
      chip: {
        label: "Nuevo",
        color: "warning",
        size: "small"
      }
    },
    {
      id: "documentation",
      title: <FormattedMessage id="Inicio" />,
      type: "item",
      url: "/inicio",
      icon: icons.MessageText1
    },
    // {
    //   id: "Aviso General",
    //   title: <FormattedMessage id="Aviso General" />,
    //   type: "item",
    //   url: "/AvisoGeneral",
    //   icon: icons.MessageProgramming
    // },
    // {
    //   id: "Aviso Aduana",
    //   title: <FormattedMessage id="Aviso Aduana" />,
    //   type: "item",
    //   url: "/AvisoAduana",
    //   icon: icons.MessageProgramming
    // },

    {
      id: "roadmap",
      title: <FormattedMessage id="Manifiestos Estatus" />,
      type: "item",
      url: "/ManifiestoGenerados",
      icon: icons.Firstline
      // external: true,
      // target: true
    },
    {
      id: "roadmapUser",
      title: <FormattedMessage id="Reporte Usuarios " />,
      type: "item",
      url: "/ReporteUsuarios",
      icon: icons.Note
      // external: true,
      // target: true
    },
    // {
    //   id: "roadmapTramites",
    //   title: <FormattedMessage id="Tramites Aduana " />,
    //   type: "item",
    //   url: "/TramitesAduana",
    //   icon: icons.Note
    //   // external: true,
    //   // target: true
    // },
    {
      id: generarGUID(),
      title: <FormattedMessage id="Aplicacion" />,
      type: "collapse",
      icon: icons.OceanProtocol,
      chip: {
        label: "Crear Manifiestos",
        color: "success",
        size: "small"
      },
      children: [
        // {
        //   id: "roadmap",
        //   title: <FormattedMessage id="Manifiestos Guardados" />,
        //   type: "item",
        //   url: "/ManifiestoGuardados",
        //   icon: icons.FolderOpen
        //   // external: true,
        //   // target: true
        // },
        {
          id: "Manifiesto Cargado",
          title: <FormattedMessage id=" Manifiesto Cargado" />,
          type: "item",
          url: "/Manifiesto",
          icon: icons.doc
          // chip: {
          //   label: "Nuevo",
          //   color: "success",
          //   size: "small"
          // }
          // breadcrumbs: false
        },
        {
          id: "Manifiesto Vacio",
          title: <FormattedMessage id="Manifiesto Vacio" />,
          type: "item",
          url: "/ManifiestoVacio",
          icon: icons.doc
        }
        // {
        //   id: "Admended",
        //   title: <FormattedMessage id="Admended Cargado" />,
        //   type: "collapse",
        //   icon: icons.EditCargado,
        //   children: [
        //     {
        //       id: "customer-list",
        //       title: <FormattedMessage id="Modificar Datos" />,
        //       type: "item",
        //       url: "/AdmendedDatosManifiesto"
        //     },
        //     {
        //       id: "customer-card",
        //       title: <FormattedMessage id="Modificar Mercancias" />,
        //       type: "item",
        //       url: "/AdmendedEntradasManifiesto"
        //     }
        //   ]
        // },
        // {
        //   id: "Admended Vacios",
        //   title: <FormattedMessage id="Admended Vacios" />,
        //   url: "/apps/invoice/dashboard",
        //   type: "collapse",
        //   icon: icons.EditVacio,
        //   breadcrumbs: true,
        //   children: [
        //     {
        //       id: "Datos",
        //       title: <FormattedMessage id="Datos" />,
        //       type: "item",
        //       url: "/apps/invoice/create"
        //     },
        //     {
        //       id: "Agregar Mercancias",
        //       title: <FormattedMessage id="Agregar Mercancias" />,
        //       type: "item",
        //       url: "/apps/invoice/details/1"
        //     }
        //   ]
        // }
      ]
    },
    {
      id: generarGUID(),
      title: <FormattedMessage id="Catalogos" />,
      type: "collapse",
      icon: icons.NoteText,
      children: [
        // {
        //   id: "Transportista",
        //   title: <FormattedMessage id="Transportista" />,
        //   type: "item",
        //   url: "/Transportista",
        //   icon: icons.Personalcard
        // },
        {
          id: "Chofer",
          title: <FormattedMessage id="Chofer" />,
          type: "item",
          url: "/Chofer",
          icon: icons.Personalcard
        },
        {
          id: "Tractor",
          title: <FormattedMessage id="Tractor" />,
          type: "item",
          url: "/Tractor",
          icon: icons.truck
        },
        {
          id: "Remolque",
          title: <FormattedMessage id="Remolque" />,
          type: "item",
          url: "/Remolque",
          icon: icons.validation
        },

        {
          id: "Broker",
          title: <FormattedMessage id="Broker" />,
          type: "item",
          url: "/Broker",
          icon: icons.broker
        },
        {
          id: "Remitente",
          title: <FormattedMessage id="Remitente" />,
          type: "item",
          url: "/Remitente",
          icon: icons.usr
        },
        {
          id: "Consignatario",
          title: <FormattedMessage id="Consignatario" />,
          type: "item",
          url: "/Consignatario",
          icon: icons.usr
        }
      ]
    }
  ]
};

const Menu_T_AND_A: NavItemType = {
  id: "other",
  title: <FormattedMessage id="others" />,
  type: "group",
  children: [
    {
      id: "sample-page",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      url: "/dashboard",
      icon: icons.Chart,
      // external: true,
      // target: true,
      chip: {
        label: "Nuevo",
        color: "warning",
        size: "small"
      }
    },
    {
      id: "documentation",
      title: <FormattedMessage id="Inicio" />,
      type: "item",
      url: "/inicio",
      icon: icons.MessageText1
    },
    {
      id: "Aviso General",
      title: <FormattedMessage id="Aviso General" />,
      type: "item",
      url: "/AvisoGeneral",
      icon: icons.MessageProgramming
    },
    {
      id: "Aviso Aduana",
      title: <FormattedMessage id="Aviso Aduana" />,
      type: "item",
      url: "/AvisoAduana",
      icon: icons.MessageProgramming
    },
    {
      id: "roadmapTramites",
      title: <FormattedMessage id="Tramites Aduana " />,
      type: "item",
      url: "/TramitesAduana",
      icon: icons.Note
      // external: true,
      // target: true
    },
    {
      id: "roadmap",
      title: <FormattedMessage id="Manifiestos Estatus" />,
      type: "item",
      url: "/ManifiestoGenerados",
      icon: icons.Firstline
      // external: true,
      // target: true
    },
    // {
    //   id: generarGUID(),
    //   title: <FormattedMessage id="Aplicacion" />,
    //   type: "collapse",
    //   icon: icons.OceanProtocol,
    //   chip: {
    //     label: "Crear Manifiestos",
    //     color: "success",
    //     size: "small"
    //   },
    //   children: [
    //     {
    //       id: "roadmap",
    //       title: <FormattedMessage id="Manifiestos Guardados" />,
    //       type: "item",
    //       url: "/ManifiestoGuardados",
    //       icon: icons.FolderOpen
    //       // external: true,
    //       // target: true
    //     },
    //     {
    //       id: "Manifiesto Cargado",
    //       title: <FormattedMessage id=" Manifiesto Cargado" />,
    //       type: "item",
    //       url: "/Manifiesto",
    //       icon: icons.doc
    //       // chip: {
    //       //   label: "Nuevo",
    //       //   color: "success",
    //       //   size: "small"
    //       // }
    //       // breadcrumbs: false
    //     },
    //     {
    //       id: "Manifiesto Vacio",
    //       title: <FormattedMessage id="Manifiesto Vacio" />,
    //       type: "item",
    //       url: "/ManifiestoVacio",
    //       icon: icons.doc
    //     }
    //     // {
    //     //   id: "Admended",
    //     //   title: <FormattedMessage id="Admended Cargado" />,
    //     //   type: "collapse",
    //     //   icon: icons.EditCargado,
    //     //   children: [
    //     //     {
    //     //       id: "customer-list",
    //     //       title: <FormattedMessage id="Modificar Datos" />,
    //     //       type: "item",
    //     //       url: "/AdmendedDatosManifiesto"
    //     //     },
    //     //     {
    //     //       id: "customer-card",
    //     //       title: <FormattedMessage id="Modificar Mercancias" />,
    //     //       type: "item",
    //     //       url: "/AdmendedEntradasManifiesto"
    //     //     }
    //     //   ]
    //     // },
    //     // {
    //     //   id: "Admended Vacios",
    //     //   title: <FormattedMessage id="Admended Vacios" />,
    //     //   url: "/apps/invoice/dashboard",
    //     //   type: "collapse",
    //     //   icon: icons.EditVacio,
    //     //   breadcrumbs: true,
    //     //   children: [
    //     //     {
    //     //       id: "Datos",
    //     //       title: <FormattedMessage id="Datos" />,
    //     //       type: "item",
    //     //       url: "/apps/invoice/create"
    //     //     },
    //     //     {
    //     //       id: "Agregar Mercancias",
    //     //       title: <FormattedMessage id="Agregar Mercancias" />,
    //     //       type: "item",
    //     //       url: "/apps/invoice/details/1"
    //     //     }
    //     //   ]
    //     // }
    //   ]
    // },
    {
      id: generarGUID(),
      title: <FormattedMessage id="Catalogos" />,
      type: "collapse",
      icon: icons.NoteText,
      children: [
        {
          id: "Transportista",
          title: <FormattedMessage id="Transportista" />,
          type: "item",
          url: "/Transportista",
          icon: icons.Personalcard
        },
        {
          id: "Usuarios",
          title: <FormattedMessage id="Usiarios" />,
          type: "item",
          url: "/Usuarios",
          icon: icons.Personalcard
        },
        // {
        //   id: "Tractor",
        //   title: <FormattedMessage id="Tractor" />,
        //   type: "item",
        //   url: "/Tractor",
        //   icon: icons.truck
        // },
        // {
        //   id: "Remolque",
        //   title: <FormattedMessage id="Remolque" />,
        //   type: "item",
        //   url: "/Remolque",
        //   icon: icons.validation
        // },

        // {
        //   id: "Broker",
        //   title: <FormattedMessage id="Broker" />,
        //   type: "item",
        //   url: "/Broker",
        //   icon: icons.broker
        // },
        // {
        //   id: "Remitente",
        //   title: <FormattedMessage id="Remitente" />,
        //   type: "item",
        //   url: "/Remitente",
        //   icon: icons.usr
        // },
        // {
        //   id: "Consignatario",
        //   title: <FormattedMessage id="Consignatario" />,
        //   type: "item",
        //   url: "/Consignatario",
        //   icon: icons.usr
        // }
      ]
    }
  ]
};
let support: NavItemType;
switch (
  sessionStorage.getItem("rol") //
) {
  case "T":
    support = Menu_T_AND_M;
    break;
  case "C":
    support = Menu_T_AND_M;
    break;
  case "M":
    support = Menu_T_AND_M;
    break;
  case "A":
    support = Menu_T_AND_A;
    break;
  default:
    support = Menu_T_AND_M;
    break;
}

export default support;
